import messagesEn from './translations/en.json';
import { Languages, LocaleMessages } from './domains/locales';

const messages: LocaleMessages = {
  [Languages.EN]: messagesEn as any,
};
export default messages;
